import React from "react";
import {
  FiArrowLeft,
  FiCheckCircle,
  FiCreditCard,
  FiShield,
} from "react-icons/fi";

const DemoPaymentPage = ({
  setScreen,
  repaymentData,
}) => {
  const paymentType =
    repaymentData?.paymentType || "full";

  const amount =
    Number(repaymentData?.amount) || 23800;

  const formattedAmount =
    amount.toLocaleString("en-IN");

  const handlePayment = () => {
    /*
     * DEMO PAYMENT
     *
     * Later Razorpay/API integration will come here.
     */

    console.log("Demo payment completed:", {
      paymentType,
      amount,
    });

    setScreen("/apply-new/paymentSuccess");
  };

  return (
    <section className="fw-screen fw-demo-payment fw-fade">

      <header className="fw-demo-payment__header">
        <button
          type="button"
          className="fw-demo-payment__back"
          onClick={() =>
            setScreen("/apply-new/repayment")
          }
        >
          <FiArrowLeft />
        </button>

        <h1>Payment</h1>
      </header>
      <div className="fw-demo-payment__intro">
        <span className="fw-demo-payment__icon">
          <FiCreditCard />
        </span>

        <p className="fw-demo-payment__eyebrow">
          SECURE PAYMENT
        </p>

        <h2>Complete Your Payment</h2>
        <h3>QR section </h3>
        <p>
          You are about to make a repayment
          towards your active loan.
        </p>
      </div>

      <div className="fw-demo-payment__amount-card">

        <span>Amount to Pay</span>

        <strong>
          ₹{formattedAmount}
        </strong>

        <small>
          {paymentType === "partial"
            ? "Part Payment"
            : "Full Payment"}
        </small>
      </div>

      {/* Payment Method */}
      <div className="fw-demo-payment__method">

        <div className="fw-demo-payment__method-icon">
          <FiCreditCard />
        </div>

        <div>
          <strong>Online Payment</strong>

          <p>
            Credit Card / Debit Card / UPI /
            Net Banking
          </p>
        </div>
      </div>

      {/* Security */}
      <div className="fw-demo-payment__secure">

        <FiShield />

        <div>
          <strong>100% Secure Payment</strong>

          <p>
            Your payment is processed through
            a secure payment gateway.
          </p>
        </div>
      </div>

      <div className="fw-demo-payment__demo">
        <span>
          <FiCheckCircle />
        </span>

        <p>
          This is a demo payment screen.
          No real money will be deducted.
        </p>

      </div>

      <div className="fw-demo-payment__footer">

        <button
          type="button"
          className="fw-btn fw-btn--primary fw-btn--full"
          onClick={handlePayment}
        >
          Pay ₹{formattedAmount}
        </button>

        <p>
          Powered by Razorpay
        </p>

      </div>

    </section>
  );
};

export default DemoPaymentPage;